var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Echarts',{ref:"bar",attrs:{"options":_vm.options,"theme":"ovilia-green","autoresize":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }